export default __webpack_public_path__ + "static/media/stripe-circle.a6f24abd.svg";